export default __webpack_public_path__ + "static/media/app-x86-release.75a51e37.apk";